import { IconFileInvoice, IconLoader } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import { MantineLinkCell } from "../../../../../mantine/mrt/components/cell/MantineLinkCell";
import { InvoiceType } from "../../../../../types/neWebApi.types";
import type { PPAInvoice, PPAInvoiceId } from "../../PPAInvoicePage.types";

export function getFilenameColumn(
  isDownloadingInvoice: (invoiceId: PPAInvoiceId) => boolean,
  onDownloadInvoice: (invoiceId: PPAInvoiceId) => void
): MRT_ColumnDef<PPAInvoice> {
  return {
    accessorKey: "filename",
    header: "Dokument",
    enableCellHoverReveal: true,
    enableColumnFilter: false,
    size: 300,
    Cell: ({ renderedCellValue, row }) =>
      row.original.invoice_type === InvoiceType.Draft ? (
        <MantineIconCell
          IconComponent={IconFileInvoice}
          renderedCellValue={renderedCellValue}
        />
      ) : (
        <MantineLinkCell
          IconComponent={
            isDownloadingInvoice(row.original.unique_identifier)
              ? IconLoader
              : IconFileInvoice
          }
          renderedCellValue={renderedCellValue}
          onClick={() => onDownloadInvoice(row.original.unique_identifier)}
        />
      )
  };
}
